import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapPaymentRepairToServer } from "./mappers/mapPaymentRepairToServer";
export const addRepairPayment = async (sessionKey, payment) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/add/payment`,
            method: "PUT",
            data: mapPaymentRepairToServer(payment),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
